import * as React from "react";
const SvgFiRrFaceAngryHorns = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-angry-horns_svg__a)">
      <path
        fill="#062147"
        d="m22.834 6.875 1.15-5.69A1 1 0 0 0 22.586.092l-4.033 1.87A11.92 11.92 0 0 0 12 0C9.581 0 7.333.726 5.446 1.96L1.414.09A.999.999 0 0 0 .017 1.186l1.15 5.688A11.9 11.9 0 0 0 0 12c0 6.617 5.383 12 12 12s12-5.384 12-12c0-1.836-.426-3.57-1.166-5.126M12 22C6.486 22 2 17.516 2 12 2 6.488 6.486 2 12 2s10 4.487 10 10c0 5.515-4.486 10-10 10m5.666-5.745a1 1 0 1 1-1.332 1.492C16.316 17.73 14.331 16 12 16s-4.316 1.73-4.336 1.747a1 1 0 0 1-1.41-.084 1 1 0 0 1 .08-1.408C6.437 16.163 8.894 14 12 14s5.563 2.162 5.666 2.254M18.8 7.4a1 1 0 0 1-.197 1.4l-1.675 1.261c.043.14.073.286.073.44a1.5 1.5 0 0 1-3 0c0-.466.217-.878.551-1.153l.002-.002L17.4 7.2a1 1 0 0 1 1.4.197zM7.073 10.062 5.398 8.8a1 1 0 0 1 1.203-1.597l2.846 2.145.002.002c.334.275.551.686.551 1.152a1.5 1.5 0 0 1-3 0c0-.154.03-.3.073-.439z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-angry-horns_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceAngryHorns;
